import { BadWordsDomain } from '@ally/data-types-host'
import { useHostServices } from '../HostServices'

export const defaultBadWords: BadWordsDomain = {
  lastUpdated: '',
  note: '',
  base: [],
  names: [],
  substring: [],
}

/**
 * A default value is used instead of a loading state because the likelihood of
 * a user reaching an text input before bad words loads is too slim to code
 * against. If a static JSON file does not load, then there are bigger problems.
 */
export const useBadWords = (): BadWordsDomain => {
  const { hostData } = useHostServices()
  return hostData.badWords?.data || defaultBadWords
}
